import React from 'react'
import tw from 'tailwind-styled-components'
import {Lang} from 'yougile-lang'
import {Hub} from 'yougile-model'
import {Tracking} from '@common/tracking'
import {TrackingEvent} from '@common/tracking-events'
import {IconButtonNew} from '@components/common/base/buttons'
import {Tooltip} from '@components/common/tooltip/tooltip'
import {isMirroredHub} from './is-mirrored-hub'
import {useRefreshWhenUpdatedMirrors} from './use-updated-mirrores'

const TwIconButtonNew = tw(IconButtonNew)<{
  $isTaskColored?: boolean
  $isCompleted?: boolean
}>`
  ${p => {
    return p.$isTaskColored
      ? `!text-icon-primary ${
          p.$isCompleted
            ? 'opacity-[.38] hover:opacity-[.64] active:opacity-[.64]'
            : 'opacity-[.64] hover:opacity-100 active:opacity-100'
        }`
      : `${
          p.$isCompleted ? 'text-placeholder-new' : 'text-icon-secondary'
        } hover:text-action-hover active:text-action-pressed`
  }}
`

export const TaskCardMirrorIcon = (props: {
  task?: Hub
  onToggle?: () => void
  className?: string
  isTaskColored?: boolean
  isCompleted?: boolean
}) => {
  useRefreshWhenUpdatedMirrors(props)

  const isMirror = isMirroredHub(props.task)
  if (!isMirror) {
    return null
  }

  return (
    <Tooltip content={Lang.msg.subtask.openSubtasks} placement="bottom-start">
      <TwIconButtonNew
        $isTaskColored={props.isTaskColored}
        $isCompleted={props.isCompleted}
        className={props.className}
        icon="IconCustomMirroredTask"
        onClick={e => {
          e.stopPropagation()
          props?.onToggle?.()
          void Tracking.send(TrackingEvent.subtasksOpenTree)
        }}
      />
    </Tooltip>
  )
}
